import { CustomerOrders } from '@src/containers/Blotters/CustomerOrders';
import type { CustomerOrdersBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CustomerOrdersPanel({ params, api }: LayoutPanelProps<CustomerOrdersBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CustomerOrdersBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="customer-orders-blotter-panel"
      >
        <CustomerOrders />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
